import { Button, IconChevronRight, IconCheckmarkCircle } from "@veneer/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "../../assets/css/views/support/SupportActivity.css";
import supportService from "../../services/supportApi/support.service";
import parse, { DOMNode, Element } from "html-react-parser";
import { HtmlImageRendererWeb } from "./components/HtmlImageRendererWeb";

const SupportActivity = () => {
  const [t] = useTranslation("global");
  const [step, setStep] = useState(0);
  const [path, setPath] = useState<any[]>([]);
  const [questions, setQuestions] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const renderWithCustomImages = (htmlString: string) =>
    parse(htmlString, {
      replace: (domNode: DOMNode) => {
        if (
          domNode &&
          typeof domNode === "object" &&
          "name" in domNode &&
          domNode.name === "img" &&
          "attribs" in domNode
        ) {
          const element = domNode as Element;
          const src = element.attribs?.src;
          const alt = element.attribs?.alt || "";

          return <HtmlImageRendererWeb src={src} alt={alt} />;
        }
      },
    });

  const getSupportData = async () => {
    setLoading(true);
    try {
      const response = await supportService.getSupportList(2);
      if (response) {
        setQuestions(response);
      }
    } catch (error) {
      console.error("Error fetching support data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSupportData();
  }, []);

  const handleSelect = (item: any) => {
    setPath([...path, item]);
    setStep(step + 1);
  };

  const handleBack = () => {
    setPath(path.slice(0, -1));
    setStep(step - 1);
  };

  const handleRestart = () => {
    setPath([]);
    setStep(0);
  };

  const renderQuestionTitle = () => {
    if (step === 0) return "¿A qué rama pertenece el inconveniente que tienes?";
    if (step === 1)
      return `¿Qué problema estás experimentando con ${path[0].categoryName.toLowerCase()}?`;
    if (step === 2 && path[1]?.subQuestions)
      return "Selecciona el caso específico que estás experimentando:";
    return "Solución encontrada:";
  };

  const renderTimeline = () => (
    <div className="timeline">
      {path.map((stepItem, idx) => (
        <div key={idx} className="timeline-step">
          <IconCheckmarkCircle size={18} />
          <span>{stepItem.categoryName || stepItem.title}</span>
        </div>
      ))}
    </div>
  );

  const renderOptions = (items: any[]) =>
    items.map((item, idx) => (
      <div
        key={idx}
        className="support-option"
        onClick={() => handleSelect(item)}
      >
        <IconChevronRight />
        <span>{item.categoryName || item.title}</span>
      </div>
    ));

  const renderResponses = () => {
    const responses = path[2]?.responses || path[1]?.responses || [];
    return (
      <div className="support-responses">
        {responses.map((resp: any, idx: number) => (
          <div key={idx} className="response-block">
            {resp.type === "text" && <p>{resp.CONTENT}</p>}
            {resp.type === "rich-text" && renderWithCustomImages(resp.CONTENT)}
          </div>
        ))}
        <Button
          appearance="secondary"
          onClick={() => alert("Abrir formulario")}
        >
          ¿Aún necesitas ayuda? Contáctanos
        </Button>
      </div>
    );
  };

  const renderContent = () => {
    if (loading) return <p>Cargando...</p>;

    if (step === 0) return renderOptions(questions);
    if (step === 1) return renderOptions(path[0]?.questions || []);
    if (step === 2 && path[1]?.subQuestions)
      return renderOptions(path[1].subQuestions);
    return renderResponses();
  };

  return (
    <div className="support-container">
      {renderTimeline()}
      <h2 className="support-title">{renderQuestionTitle()}</h2>
      <div className="support-content">{renderContent()}</div>

      <div className="support-footer">
        {step > 0 && (
          <>
            <Button appearance="secondary" onClick={handleBack}>
              Volver
            </Button>
            <Button onClick={handleRestart}>Reiniciar</Button>
          </>
        )}
      </div>
    </div>
  );
};

export default SupportActivity;
